export default __webpack_public_path__ + "static/media/biote888.380ce511.png";